import { createDecorator } from '../../instantiation/common/instantiation.js';
const IEncryptionService = ( createDecorator('encryptionService'));
export { IEncryptionService };
